import { GRadio } from 'components/basic-blocks/g-radio'
import { useFeatureFlag } from 'services/feature-flags'
import { TrackingMethod } from '../../types'

interface MethodSelectorProps {
	selectedMethod: TrackingMethod | null
	onMethodChange: (method: TrackingMethod) => void
}

export const MethodSelector = ({
	selectedMethod,
	onMethodChange
}: MethodSelectorProps) => {
	const shopifyEnabled = useFeatureFlag('shopify_enabled')
	return (
		<div className="flex flex-col gap-4">
			<GRadio
				value="gtm"
				checked={selectedMethod === 'gtm'}
				onChange={() => onMethodChange('gtm')}
				labelClass="font-medium text-[16px] leading-[22px] text-t-google-tooltip"
				label="Install with Google Tag Manager"
				name="tracking-method"
				helpToolTip="Use Google Tag Manager to install the tracking code automatically"
				tooltipPosition="top"
			/>
			<GRadio
				value="manual"
				checked={selectedMethod === 'manual'}
				onChange={() => onMethodChange('manual')}
				labelClass="font-medium text-[16px] leading-[22px] text-t-google-tooltip"
				label="Install manually"
				name="tracking-method"
				helpToolTip="Copy and paste the tracking code directly into your website's HTML"
				tooltipPosition="top"
			/>
			{shopifyEnabled && (
				<GRadio
					value="shopify"
					checked={selectedMethod === 'shopify'}
					onChange={() => onMethodChange('shopify')}
					labelClass="font-medium text-[16px] leading-[22px] text-[#444346]"
					label="Install on Shopify Store"
					name="tracking-method"
					helpToolTip="Connect your Shopify store to install the ClickGUARD app and enable conversion tracking"
					tooltipPosition="top"
				/>
			)}
			<GRadio
				value="email"
				checked={selectedMethod === 'email'}
				onChange={() => onMethodChange('email')}
				labelClass="font-medium text-[16px] leading-[22px] text-t-google-tooltip"
				label="Email my developer"
				name="tracking-method"
				helpToolTip="Send the tracking code installation instructions to your developer via email"
				tooltipPosition="top"
			/>
		</div>
	)
}
